import { Tooltip } from "../../Feedback/Tooltip";
import { CopyableValue } from "../../Display/CopyableValue";
import { CopyableProvider } from "../../Display/Internal/CopyableContext";
import { BadgeSizeContext } from "../../Display/BadgeSizeContext";
import { formatStatValue } from "../Helpers/formatStatValue";
import { StatValueLink_ } from "./StatValueLink";
import { StatValueButton_ } from "./StatValueButton";
import type { StatEntry } from "../Types/StatItemType";
import { isStatDivider } from "../Types/StatItemType";

export function TabStats_({ items }: { items: StatEntry[] }) {
  // Reveal the copy icon only on hover so the stat row stays uncluttered.
  const copyMode = "reveal";
  return (
    <CopyableProvider value={copyMode}>
      {/* Shrink any Badge used as a stat value so badge-valued stats
          don't tower over the numeric ones */}
      <BadgeSizeContext.Provider value="small">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {items.map((entry) => {
            if (isStatDivider(entry)) {
              return (
                <div
                  key={entry.dividerId}
                  className="h-7 w-px shrink-0 bg-foreground/15"
                />
              );
            }
            const item = entry;
            return (
              <div key={item.statKey ?? String(item.label)}>
                <div className="flex items-center gap-1 text-[10px] font-semibold tracking-wide text-content-muted uppercase">
                  {item.label}
                  {item.tooltip && (
                    <Tooltip variant="info" size="sm" content={item.tooltip} />
                  )}
                </div>
                <div className="mt-0.5 text-sm font-bold text-foreground">
                  {item.href ? (
                    <StatValueLink_ item={item} />
                  ) : item.onClick ? (
                    <StatValueButton_ item={item} />
                  ) : item.action ? (
                    <span className="inline-flex items-center gap-2">
                      <CopyableValue
                        value={formatStatValue(item)}
                        copyValue={item.copyValue}
                        copyOptions={item.copyOptions}
                        label={item.label}
                      />
                      {item.action}
                    </span>
                  ) : (
                    <CopyableValue
                      value={formatStatValue(item)}
                      copyValue={item.copyValue}
                      copyOptions={item.copyOptions}
                      label={item.label}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </BadgeSizeContext.Provider>
    </CopyableProvider>
  );
}
